export const getMinMaxTotalVariationsCount = (min: number, max: number, stepSize: number) => {
    return Math.floor( Number((Number((max - min).toPrecision(10)) / stepSize).toPrecision(10))) + 1;
    
}

export const getStepsBeforeAfterVariationsCount = (stepsBefore: number, stepsAfter: number) => {
    return Number(stepsBefore) + Number(stepsAfter) + 1;
}